export default [
    {
        path: 'pipeline/list/:productId?/:filterParams?/:isShowDialog?',
        name: 'pipelineList',
        meta: {
            requiresAuth: true
        },
        component: () => import('@/views/pipeline/List')
    },
    {
        path: 'pipeline/tab_list/:type?/:objectId?',
        name: 'pipelineTabList',
        meta: {
            requiresAuth: true
        },
        component: () => import('@/views/pipeline/TabList')
    },
    {
        path: 'pipeline/detail/:pipelineId/:tabKey?',
        name: 'pipelineDetail',
        meta: {
            requiresAuth: true
        },
        component: () => import('@/views/pipeline/Detail')
    },
    {
        path: 'pipeline/detail/:pipelineId/build/:buildId',
        name: 'buildDetail',
        meta: {
            requiresAuth: true
        },
        component: () => import('@/views/pipeline/History')
    }
];